export interface SandboxClientOptions {
  serverUrl: string
  onConnected?: () => void
  onMessageReceived?: (data: string) => void
  onError?: (error: any) => void
  onDisconnected?: () => void
}

export class SandboxClient {
  private ws?: WebSocket

  public start(opts: SandboxClientOptions) {
    this.ws = new WebSocket(opts.serverUrl)
    this.ws.onopen = () => opts.onConnected?.()
    this.ws.onmessage = (event) => opts.onMessageReceived?.(event.data)
    this.ws.onerror = (error) => opts.onError?.(error)
    this.ws.onclose = () => opts.onDisconnected?.()
  }

  public send(data: any) {
    this.ws?.send(JSON.stringify(data))
  }

  public close() {
    if (!this.ws) {
      return
    }

    // detach handlers before closing so a pending close/error from this socket
    // can't fire callbacks after an intentional teardown (unmount, reconnect)
    this.ws.onopen = null
    this.ws.onmessage = null
    this.ws.onerror = null
    this.ws.onclose = null
    this.ws.close()
    this.ws = undefined
  }
}
